export const canDisplayCustomMarkers = (contest) => {
  return contest.collectionId !== 2;
};

export const canDisplayContestNews = (contest) => {
  return contest.collectionId !== 2;
};
